import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  Type,
} from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core'
import { FormlyFieldProps } from '@ngx-formly/ng-zorro-antd/form-field'
import { NzSizeLDSType } from 'ng-zorro-antd/core/types'
import { NzInputDirective, NzInputGroupComponent } from 'ng-zorro-antd/input'
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number'

interface FormlyInputProps extends FormlyFieldProps {
  size?: NzSizeLDSType
  prefix?: string | TemplateRef<void>
  suffix?: string | TemplateRef<void>
}

export interface FormlyInputFieldConfig
  extends FormlyFieldConfig<FormlyInputProps> {
  type: 'input' | 'number' | Type<NzInputFieldTypeComponent>
}

@Component({
  selector: 'formly-field-nz-input',
  templateUrl: './nz-input-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NzInputDirective,
    ReactiveFormsModule,
    FormlyModule,
    NzInputNumberComponent,
    NzInputGroupComponent,
  ],
})
export class NzInputFieldTypeComponent extends FieldType<
  FieldTypeConfig<FormlyInputProps>
> {}
